import HistoricMailsModalInfoView from "../historic_mails/historic_mails-modal_info.html";


angular.module('events')

    .controller('historicMailsModalCtrl', ['$scope', '$uibModalInstance', '$uibModal', 'options', '$filter', 'gridService', 'Restangular', 'logService',
        function ($scope, $uibModalInstance,$uibModal, options, $filter, gridService, Restangular, logService) {

        logService.debug(options);


        $scope.gridOptionHistoricMails = {
            pdfTitle: $filter('translate')('events.historic_mails.historic_mails'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            enableSorting: true,
            paginationPageSizes: [5, 10, 20],
            paginationPageSize: 5,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              {
                  name: 'mail_date', field: 'mail_date', displayName: $filter('translate')('events.historic_mails.mail_date'),
                  enableFiltering: false, enableHiding: true, cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm\'', width: 120
              },
              { name: 'subject', field: 'subject', displayName: $filter('translate')('events.historic_mails.subject'), enableFiltering: false, enableHiding: true },
              { name: 'to', field: 'to', displayName: $filter('translate')('events.historic_mails.to'), enableFiltering: false, enableHiding: true },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: "", action: 'ng-click="grid.appScope.infoModal(row.entity.id)"', cssIconClass: "fa fa-info" },
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (optionsGrid) {
                optionsGrid.module = options.module;
                optionsGrid.code = options.code;
                optionsGrid.event_id = options.event_id;
                optionsGrid.to = options.to;
                return Restangular.all('HistoricMails').getList(optionsGrid);
            }
        };
        /**
             * Abre el modal con la información del mail.
             */
        $scope.infoModal = function (id) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: HistoricMailsModalInfoView,
                size: "lg",
                controller: "HistoricMailModalCtrl",
                resolve: {
                    options: function () {
                        return { id: id };
                    }
                }
            });
            //Response del modal
            $modalInstance.result.then(function () {
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
                if (!$scope.$$phase) $scope.$apply();
            });
        }


        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }]);